import { UPDATE_DRIVERS } from '../constants';

const DEFAULT_STATE = {
  drivers: {},
};

const DriversReducer = (state = DEFAULT_STATE, { type, payload }) => {
  switch (type) {
    case UPDATE_DRIVERS:
      payload.forEach((driver) => (state.drivers[driver.id] = driver));
      return {
        ...state,
      };

    default:
      return state;
  }
};

export default DriversReducer;
